import React, { useEffect, useState } from "react";
import "./kakaoMap.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  fetchAllDeviceData,
  selectDeviceAllInfoData,
  selectDeviceType,
  userCheckInu,
  userCheckWal,
} from "../../store/deviceData/deviceDataSlice";

export default function MapContainer() {


  const deviceAllInfoData = useAppSelector(selectDeviceAllInfoData);
  const dispatch = useAppDispatch();
  const deviceType = useAppSelector(selectDeviceType);
  const [search, setSearch] = useState<string>("");
  useEffect(() => {
    dispatch(fetchAllDeviceData({ deviceType, search, searchType: "prd_id" }));
  }, [deviceType, search]);
  useEffect(() => {
    let mapContainer = document.getElementById("map"),
      mapOption = {
        center: new kakao.maps.LatLng(35.2417951, 129.0834828),
        level: 3,
      };

    let map = new kakao.maps.Map(mapContainer!, mapOption);
    deviceAllInfoData.filter((e) => e.lat != null).forEach((item) => {
      let marker = new kakao.maps.Marker({
        map: map,
        position: new kakao.maps.LatLng(item.lat, item.lng),
        zIndex: 2,
      });
      kakao.maps.event.addListener(marker, "click", function () {
        const markerLocatin = marker.getPosition();
        overlay.setPosition(markerLocatin);
        overlay.setMap(map);
      });


      var content2 = document.createElement('div');
      content2.innerHTML =  'test';
      content2.style.cssText = 'background: white; border: 1px solid black';
      
      var closeBtn = document.createElement('button');
      closeBtn.innerHTML = '닫기';
      closeBtn.onclick = function () {
          overlay.setMap(null);
      };
      content2.appendChild(closeBtn);
      let overlay = new kakao.maps.CustomOverlay({
        // content: content,
        map: map,
        position: marker.getPosition(),
        zIndex: 10,

      });

      overlay.setContent(content2);
      const close2 = document.getElementById(item.spot_code!)
      console.log(close2)
      const close = document.querySelectorAll(".close");
      console.log(close)
      close.forEach((element) => {
        element.addEventListener("click", function () {
          overlay.setMap(null);
        });
      });
      overlay.setMap(null);
    })
  }, [kakao, deviceAllInfoData]);
  return (
    <div>
      <div
        id="map"
        style={{
          width: "1000px",
          height: "1000px",
        }}
      ></div>
    </div>
  );
}